import { createContext } from 'preact'
import { useState, useContext, useMemo, useCallback } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { useOption } from 'libs/searchspring/hooks/useOption'

const SortContext = createContext()

export function SortProvider({ children }) {
  const { results, refine, clear } = useSearchspringContext()
  const [isOpen, setIsOpen] = useState(false)

  const sorts = useMemo(() => {
    return (
      results?.sorting?.options?.map((option) => ({
        label: option.label,
        value: `${option.field}:${option.direction}`
      })) ?? []
    )
  }, [results?.sorting])

  const activeSort = useOption('sort', {
    syncWithURL: true
  })

  const handleSort = useCallback((sort) => {
    if (sort !== activeSort) {
      refine('sort', sort)
      refine('page', 1)
    }
  }, [activeSort, refine])

  const resetSort = useCallback(() => {
    clear('sort')
    refine('page', 1)
  }, [clear, refine])

  const value = {
    isOpen,
    setIsOpen,
    sorts,
    activeSort,
    handleSort,
    resetSort
  }

  return <SortContext.Provider value={value}>{children}</SortContext.Provider>
}

export function useSort() {
  const context = useContext(SortContext)
  if (!context) {
    throw new Error('useFilters must be used within a SortProvider')
  }
  return context
}
